'use client'

import { useMutation } from '@apollo/client'
import { useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { gql } from '~/__generated__'

const CREATE_SHARE_OPEN = gql(`
  mutation createShareOpen($token: String!, $referenceUrl: String) {
    createShareOpen(input: { token: $token, referenceUrl: $referenceUrl }) {
      success
      errors
    }
  }
`)

const LOCAL_STORAGE_KEY = 'lastShareToken'

export const ShareOpenTracker = () => {
  const searchParams = useSearchParams()
  const shareToken = searchParams?.get('shareToken') ?? null
  const [createShareOpen] = useMutation(CREATE_SHARE_OPEN)
  const calledTokenRef = useRef<string | null>(null)

  useEffect(() => {
    if (!shareToken) return
    if (calledTokenRef.current === shareToken) return

    calledTokenRef.current = shareToken
    createShareOpen({
      variables: {
        token: shareToken,
        referenceUrl: window.location.href,
      },
    })
      .then(() => {
        localStorage.setItem(LOCAL_STORAGE_KEY, shareToken)
      })
      .catch(() => {
        // Silently ignore errors to avoid disrupting UX
        calledTokenRef.current = null
      })
  }, [shareToken, createShareOpen])

  return null
}
